import { useState, type FormEvent } from "react";
import { api, ApiError } from "../../api/client";

/**
 * Wiederverwendbares Passwort-Änderungsformular für den eigenen Account -
 * verwendet von der Seite "Passwort ändern" (für jeden Benutzer über die
 * Sidebar erreichbar) sowie von "Mein Profil". Nutzt denselben Endpunkt wie
 * ForcedPasswordChange.tsx (POST /api/auth/change-password), der serverseitig
 * das aktuelle Passwort prüft und ausschließlich das EIGENE Konto des
 * angemeldeten Benutzers ändert (keine Fremdänderung möglich). Da Sessions
 * zustandslos (JWT) sind, bleibt der Benutzer nach erfolgreicher Änderung
 * automatisch eingeloggt - es gibt keine serverseitige Sitzung, die
 * invalidiert werden müsste.
 */
export function ChangePasswordForm() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState<{ type: "success" | "error"; text: string } | null>(null);
  const [submitting, setSubmitting] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setMessage(null);
    if (newPassword !== confirmPassword) {
      setMessage({ type: "error", text: "Die neuen Passwörter stimmen nicht überein." });
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/api/auth/change-password", { currentPassword, newPassword });
      setMessage({ type: "success", text: "Passwort erfolgreich geändert." });
      setCurrentPassword(""); setNewPassword(""); setConfirmPassword("");
    } catch (err) {
      setMessage({ type: "error", text: err instanceof ApiError ? err.message : "Fehler beim Ändern des Passworts." });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {message && (
        <div className={`text-sm rounded-lg px-3 py-2 ${message.type === "success" ? "bg-success-muted text-success" : "bg-danger-muted text-danger"}`}>
          {message.text}
        </div>
      )}
      <div>
        <label className="label">Aktuelles Passwort</label>
        <input className="input" type="password" value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} autoComplete="current-password" required />
      </div>
      <div>
        <label className="label">Neues Passwort</label>
        <input className="input" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} autoComplete="new-password" minLength={8} required />
      </div>
      <div>
        <label className="label">Neues Passwort bestätigen</label>
        <input className="input" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} autoComplete="new-password" minLength={8} required />
      </div>
      <button className="btn-primary" disabled={submitting}>{submitting ? "Speichern…" : "Passwort ändern"}</button>
    </form>
  );
}
